import React from 'react';
import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Reactor from 'data/reactor';
import RuntimeGetters from 'data/app-runtime/getters';
import { findShowMethodForModal } from 'utils/runtime';
import { sharedModalReferences } from 'resources/common-values';
import Actions from 'data/actions';
import Cookies from 'js-cookie';

export default CreateReactClass({
    displayName: 'UserMenu',

    propTypes: {
        username: PropTypes.string,
        route: PropTypes.string,
    },

    /**
     * Handles the supplied link click event, storing the linkName within analytics.  This will show a confirmation
     * dialog to users if they have unsaved data changes, allowing the user to stay on the current page and save any
     * changes they have made before moving onto another page.
     * @param e The click event proxy generated by React
     * @param linkName The name of the link which was clicked so that it may be tracked via analytics.
     */
    handleLinkClick(e, linkName) {
        //Record the link which was clicked
        Analytics.recordButtonClick(CommonValues.SectionIDs.header, linkName);
        if(linkName =='logout'){
            Cookies.remove('cl-token', { domain: '.mapnwea.org' });
            window.location.replace(CommonValues.getLogoutURL(window.location.hostname)); 
        }
        
        //Show the save changes prompt if there is unsaved data
        if (Reactor.evaluate(RuntimeGetters.unsavedData)) {
            const showSaveDataPrompt = findShowMethodForModal(
                Reactor.evaluate(RuntimeGetters.modalReferences),
                sharedModalReferences.saveDataPrompt
            );
            //Note this matches the rendered html below
            const linkTarget = e.nativeEvent.target.href;
            e.preventDefault();
            showSaveDataPrompt()
                .then(() => {
                    Actions.runtime.setUnsavedData(false);
                    //now follow the link as supplied by the original event
                    window.location.href = linkTarget;
                })
                .catch(() => {
                    /* do nothing */
                });
        }
    },

    render() {
        const today = new Date();
        const currentDate = today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear();
        let helpLink = '/assist/help_map/ApplicationHelp_CSH.htm#641';
        if (this.props.route && this.props.route.includes('family-report')) {
            helpLink = '/assist/help_map/ApplicationHelp_CSH.htm#812';
        }
        return (
            <div className={'top-header-right'} key="header-right">
                <div id="login-status" key="login-status" className="login-status">
                    <span key="logged-in-as" className="screen-only">
                        Logged in as{' '}
                    </span>
                    <span key="exported-as" className="print-only exported-by">
                        Exported by{' '}
                    </span>
                    <span className="text-bold" key="username">
                        {this.props.username}
                    </span>
                    <span key="exported-on" className="print-only print-date">
                        on {currentDate}
                    </span>
                </div>
                <div className="header-links-holder" key="links">
                    <a key="header-link-home" href="/admin/home.seam" onClick={(e) => this.handleLinkClick(e, 'home')}>
                        Home
                    </a>

                    <a
                        key="header-link-help"
                        href={helpLink}
                        target="_blank"
                        onClick={() => Analytics.recordButtonClick(CommonValues.SectionIDs.header, 'help')}
                    >
                        Help
                    </a>

                    <a
                        key="header-link-contact"
                        href="/admin/common/contact.seam"
                        onClick={(e) => this.handleLinkClick(e, 'contact')}
                    >
                        Contact
                    </a>

                    <a
                        key="header-link-change-password"
                        href="/admin/account/ChangePassword.seam"
                        onClick={(e) => this.handleLinkClick(e, 'change-password')}
                    >
                        Change Password
                    </a>

                    <a
                        key="header-link-logout"
                        href = { __BATCH__ ? "" : CommonValues.getLogoutURL(window.location.hostname)}
                        onClick={(e) => this.handleLinkClick(e, 'logout')}
                    >
                        Logout
                    </a>
                </div>
            </div>
        );
    },
});
